import { render, staticRenderFns } from "./PlaylistNav.vue?vue&type=template&id=52e4e243&"
import script from "./PlaylistNav.vue?vue&type=script&lang=ts&"
export * from "./PlaylistNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports